/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */


export default class SlotEditorDOMAPI {
	/**
	 * @function SlotEditorDOMAPI#render
	 * @description Renders slots in a given container
	 * @param {Object} options
	 * @param {Object} options.parentNode - the parent dom node for rendering the slots editor
	 */
	render() {}

	/**
	 * @function SlotEditorDOMAPI#unmount
	 * @description unmount slots
	 */
	unmount() {}

	/**
	 * @function SlotEditorDOMAPI#getProviderId
	 * @description Returns the provider id for the feature
	 * @return {String} DOM feature provider id
	 */
	getProviderId() {}

	addExtension() {}
}



// WEBPACK FOOTER //
// ./src/js/dashboard/SlotEditorDOMAPI.js